var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
export var Tick = function Tick(_a) {
  var tick = _a.tick,
      count = _a.count;
  return React.createElement("div", null, React.createElement("div", {
    style: {
      position: 'absolute',
      marginTop: 14,
      width: 1,
      height: 5,
      backgroundColor: 'rgb(200,200,200)',
      left: tick.percent + "%"
    }
  }), React.createElement("div", {
    style: {
      position: 'absolute',
      marginTop: 22,
      fontSize: 10,
      textAlign: 'center',
      marginLeft: -(100 / count) / 2 + "%",
      width: 100 / count + "%",
      left: tick.percent + "%"
    }
  }, tick.value));
};

var Handle = function Handle(_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      getHandleProps = _a.getHandleProps;
  return React.createElement("div", Object.assign({
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      marginLeft: '-11px',
      marginTop: '-6px',
      zIndex: 2,
      width: 24,
      height: 24,
      cursor: 'pointer',
      borderRadius: '50%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#19bd70'
    }
  }, getHandleProps(id)));
};

var HandleDarkMode = function HandleDarkMode(_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      getHandleProps = _a.getHandleProps;
  return React.createElement("div", Object.assign({
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      marginLeft: '-11px',
      marginTop: '-6px',
      zIndex: 2,
      width: 24,
      height: 24,
      cursor: 'pointer',
      borderRadius: '50%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#f8f9fa'
    }
  }, getHandleProps(id)));
};

var HandleSharpMode = function HandleSharpMode(_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      getHandleProps = _a.getHandleProps;
  return React.createElement("div", Object.assign({
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      marginLeft: '-6px',
      marginTop: '-5px',
      zIndex: 2,
      width: 12,
      height: 22,
      cursor: 'pointer',
      borderRadius: '10%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#DDDDDD'
    }
  }, getHandleProps(id)));
};

var HandleThinMode = function HandleThinMode(_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      getHandleProps = _a.getHandleProps;
  return React.createElement("div", Object.assign({
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      marginLeft: '-11px',
      marginTop: '-8px',
      zIndex: 2,
      width: 20,
      height: 20,
      cursor: 'pointer',
      borderRadius: '50%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#19bd70'
    }
  }, getHandleProps(id)));
};

var Track = function Track(_a) {
  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps;
  return React.createElement("div", Object.assign({
    style: {
      position: 'absolute',
      height: 14,
      zIndex: 1,
      backgroundColor: '#ff774d',
      borderRadius: 7,
      cursor: 'pointer',
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, getTrackProps()));
};

var TrackDarkMode = function TrackDarkMode(_a) {
  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps;
  return React.createElement("div", Object.assign({
    style: {
      position: 'absolute',
      height: 14,
      zIndex: 1,
      backgroundColor: '#1c1e23',
      borderRadius: 7,
      cursor: 'pointer',
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, getTrackProps()));
};

var TrackSharpMode = function TrackSharpMode(_a) {
  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps;
  return React.createElement("div", Object.assign({
    style: {
      position: 'absolute',
      height: 14,
      zIndex: 1,
      backgroundColor: '#ff774d',
      borderRadius: 1,
      cursor: 'pointer',
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, getTrackProps()));
};

var TrackThinMode = function TrackThinMode(_a) {
  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps;
  return React.createElement("div", Object.assign({
    style: {
      position: 'absolute',
      height: 7,
      zIndex: 1,
      backgroundColor: '#ff774d',
      borderRadius: 1,
      cursor: 'pointer',
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, getTrackProps()));
};

var railStyle = {
  position: 'absolute',
  width: '100%',
  height: 14,
  borderRadius: 7,
  cursor: 'pointer',
  backgroundColor: 'rgb(155,155,155)'
};
var railStyleDarkMode = {
  position: 'absolute',
  width: '100%',
  height: 14,
  borderRadius: 7,
  cursor: 'pointer',
  backgroundColor: '#adadad'
};
var railStyleSharp = {
  position: 'absolute',
  width: '100%',
  height: 14,
  borderRadius: 1,
  cursor: 'pointer',
  backgroundColor: 'rgb(155,155,155)'
};
var railStyleThin = {
  position: 'absolute',
  width: '100%',
  height: 7,
  borderRadius: 1,
  cursor: 'pointer',
  backgroundColor: 'rgb(155,155,155)'
};
var sliderStyle = {
  margin: '5%',
  position: 'relative',
  width: '90%'
};

var InputSliderBar =
/** @class */
function (_super) {
  __extends(InputSliderBar, _super);

  function InputSliderBar(props) {
    var _this = _super.call(this, props) || this;

    _this.getRailTheme = function (theme) {
      switch (theme) {
        case 'darkModeRail':
          return railStyleDarkMode;

        case 'sharpRail':
          return railStyleSharp;

        case 'thinRail':
          return railStyleThin;

        default:
          return railStyle;
      }
    };

    _this.onChange = function (values) {
      var currVal = values[0];

      _this.setState({
        currVal: currVal
      });

      _this.props.onChange(currVal);
    };

    _this.onUpdate = function (values) {
      var currVal = values[0];

      _this.setState({
        currVal: currVal
      });
    };

    _this.state = __assign(__assign({}, props), {
      values: [props.startingValue],
      currVal: props.startingValue
    });
    return _this;
  }

  InputSliderBar.prototype.render = function () {
    var _this = this;

    var values = this.state.values;
    var _a = this.props,
        minVal = _a.minVal,
        maxVal = _a.maxVal,
        tickNum = _a.tickNum,
        ticksOn = _a.ticksOn,
        theme = _a.theme;
    var domain = [minVal, maxVal];
    var tickValues = ticksOn && tickNum || -1;

    if (theme === 'darkMode') {
      return React.createElement("div", {
        style: {
          height: 100,
          width: '100%'
        }
      }, React.createElement(Slider, {
        mode: 1,
        step: 1,
        domain: domain,
        rootStyle: sliderStyle,
        values: values,
        onChange: this.onChange,
        onUpdate: this.onUpdate
      }, React.createElement(Rail, null, function (_a) {
        var getRailProps = _a.getRailProps;
        return React.createElement("div", Object.assign({
          style: _this.getRailTheme(theme + 'Rail')
        }, getRailProps()));
      }), React.createElement(Handles, null, function (_a) {
        var handles = _a.handles,
            getHandleProps = _a.getHandleProps;
        return React.createElement("div", {
          className: "slider-handles"
        }, handles.map(function (handle) {
          return React.createElement(HandleDarkMode, {
            key: handle.id,
            handle: handle,
            domain: domain,
            getHandleProps: getHandleProps
          });
        }));
      }), React.createElement(Tracks, {
        right: false
      }, function (_a) {
        var tracks = _a.tracks,
            getTrackProps = _a.getTrackProps;
        return React.createElement("div", {
          className: "slider-tracks"
        }, tracks.map(function (_a) {
          var id = _a.id,
              source = _a.source,
              target = _a.target;
          return React.createElement(TrackDarkMode, {
            key: id,
            source: source,
            target: target,
            getTrackProps: getTrackProps
          });
        }));
      }), React.createElement(Ticks, {
        count: tickValues
      }, function (_a) {
        var ticks = _a.ticks;
        return React.createElement("div", {
          className: "slider-ticks"
        }, ticks.map(function (tick) {
          return React.createElement(Tick, {
            key: tick.id,
            tick: tick,
            count: ticks.length
          });
        }));
      })));
    } else if (theme === 'sharp') {
      return React.createElement("div", {
        style: {
          height: 100,
          width: '100%'
        }
      }, React.createElement(Slider, {
        mode: 1,
        step: 1,
        domain: domain,
        rootStyle: sliderStyle,
        values: values,
        onChange: this.onChange,
        onUpdate: this.onUpdate
      }, React.createElement(Rail, null, function (_a) {
        var getRailProps = _a.getRailProps;
        return React.createElement("div", Object.assign({
          style: _this.getRailTheme(theme + 'Rail')
        }, getRailProps()));
      }), React.createElement(Handles, null, function (_a) {
        var handles = _a.handles,
            getHandleProps = _a.getHandleProps;
        return React.createElement("div", {
          className: "slider-handles"
        }, handles.map(function (handle) {
          return React.createElement(HandleSharpMode, {
            key: handle.id,
            handle: handle,
            domain: domain,
            getHandleProps: getHandleProps
          });
        }));
      }), React.createElement(Tracks, {
        right: false
      }, function (_a) {
        var tracks = _a.tracks,
            getTrackProps = _a.getTrackProps;
        return React.createElement("div", {
          className: "slider-tracks"
        }, tracks.map(function (_a) {
          var id = _a.id,
              source = _a.source,
              target = _a.target;
          return React.createElement(TrackSharpMode, {
            key: id,
            source: source,
            target: target,
            getTrackProps: getTrackProps
          });
        }));
      }), React.createElement(Ticks, {
        count: tickValues
      }, function (_a) {
        var ticks = _a.ticks;
        return React.createElement("div", {
          className: "slider-ticks"
        }, ticks.map(function (tick) {
          return React.createElement(Tick, {
            key: tick.id,
            tick: tick,
            count: ticks.length
          });
        }));
      })));
    } else if (theme === 'thin') {
      return React.createElement("div", {
        style: {
          height: 100,
          width: '100%'
        }
      }, React.createElement(Slider, {
        mode: 1,
        step: 1,
        domain: domain,
        rootStyle: sliderStyle,
        values: values,
        onChange: this.onChange,
        onUpdate: this.onUpdate
      }, React.createElement(Rail, null, function (_a) {
        var getRailProps = _a.getRailProps;
        return React.createElement("div", Object.assign({
          style: _this.getRailTheme(theme + 'Rail')
        }, getRailProps()));
      }), React.createElement(Handles, null, function (_a) {
        var handles = _a.handles,
            getHandleProps = _a.getHandleProps;
        return React.createElement("div", {
          className: "slider-handles"
        }, handles.map(function (handle) {
          return React.createElement(HandleThinMode, {
            key: handle.id,
            handle: handle,
            domain: domain,
            getHandleProps: getHandleProps
          });
        }));
      }), React.createElement(Tracks, {
        right: false
      }, function (_a) {
        var tracks = _a.tracks,
            getTrackProps = _a.getTrackProps;
        return React.createElement("div", {
          className: "slider-tracks"
        }, tracks.map(function (_a) {
          var id = _a.id,
              source = _a.source,
              target = _a.target;
          return React.createElement(TrackThinMode, {
            key: id,
            source: source,
            target: target,
            getTrackProps: getTrackProps
          });
        }));
      }), React.createElement(Ticks, {
        count: tickValues
      }, function (_a) {
        var ticks = _a.ticks;
        return React.createElement("div", {
          className: "slider-ticks"
        }, ticks.map(function (tick) {
          return React.createElement(Tick, {
            key: tick.id,
            tick: tick,
            count: ticks.length
          });
        }));
      })));
    } else {
      return React.createElement("div", {
        style: {
          height: 100,
          width: '100%'
        }
      }, React.createElement(Slider, {
        mode: 1,
        step: 1,
        domain: domain,
        rootStyle: sliderStyle,
        values: values,
        onChange: this.onChange,
        onUpdate: this.onUpdate
      }, React.createElement(Rail, null, function (_a) {
        var getRailProps = _a.getRailProps;
        return React.createElement("div", Object.assign({
          style: _this.getRailTheme(theme + 'Rail')
        }, getRailProps()));
      }), React.createElement(Handles, null, function (_a) {
        var handles = _a.handles,
            getHandleProps = _a.getHandleProps;
        return React.createElement("div", {
          className: "slider-handles"
        }, handles.map(function (handle) {
          return React.createElement(Handle, {
            key: handle.id,
            handle: handle,
            domain: domain,
            getHandleProps: getHandleProps
          });
        }));
      }), React.createElement(Tracks, {
        right: false
      }, function (_a) {
        var tracks = _a.tracks,
            getTrackProps = _a.getTrackProps;
        return React.createElement("div", {
          className: "slider-tracks"
        }, tracks.map(function (_a) {
          var id = _a.id,
              source = _a.source,
              target = _a.target;
          return React.createElement(Track, {
            key: id,
            source: source,
            target: target,
            getTrackProps: getTrackProps
          });
        }));
      }), React.createElement(Ticks, {
        count: tickValues
      }, function (_a) {
        var ticks = _a.ticks;
        return React.createElement("div", {
          className: "slider-ticks"
        }, ticks.map(function (tick) {
          return React.createElement(Tick, {
            key: tick.id,
            tick: tick,
            count: ticks.length
          });
        }));
      })));
    }
  };

  InputSliderBar.defaultProps = {
    minVal: 0,
    maxVal: 100,
    startingValue: 0,
    ticksOn: true,
    boxValue: false,
    theme: 'railStyle'
  };
  return InputSliderBar;
}(React.Component);

export default InputSliderBar;